import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { QuestionsList } from '../../../../../types/__codegen__/sanity/graphql';
import { WithOrderIndex } from '../types';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';

type Props = {
  cmsSectionContent: WithOrderIndex<QuestionsList>;
};

const mapQuestionsContent = ({ cmsSectionContent }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  return {
    items: getFormattedQuestionForAccordion(cmsSectionContent.questions),
    orderIndex: cmsSectionContent.orderIndex,
    type: CONTENT_SECTIONS.COMMON_QUESTIONS,
  };
};

export default mapQuestionsContent;
